import { render, staticRenderFns } from "./AppInstall.vue?vue&type=template&id=71bb50f4"
import script from "./AppInstall.vue?vue&type=script&lang=ts"
export * from "./AppInstall.vue?vue&type=script&lang=ts"
import style0 from "./AppInstall.vue?vue&type=style&index=0&id=71bb50f4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71bb50f4')) {
      api.createRecord('71bb50f4', component.options)
    } else {
      api.reload('71bb50f4', component.options)
    }
    module.hot.accept("./AppInstall.vue?vue&type=template&id=71bb50f4", function () {
      api.rerender('71bb50f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AppInstall.vue"
export default component.exports